import { Component } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface ConfirmModel {
  title:string;
  message:string;
  okButtonLabel:string;
  cancelButtonLabel:string;
}

@Component({
  selector: 'confirm',
  templateUrl: 'delete-confirmation.dialog.component.html'
})
export class DeleteCofirmationDialogComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  title: string;
  message: string;
  okButtonLabel:string;
  cancelButtonLabel:string;
  
  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  confirm() {
    // on click on confirm button we set dialog result as true,
    // ten we can get dialog result from caller code
    this.result = true;
    this.close();
  }
  cancel() {
    this.result = false;
    this.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/delete-confirmation/delete-confirmation.dialog.component.ts